var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-btn',{attrs:{"color":"primary","rounded":""},on:{"click":function($event){return _vm.goToPay()}}},[_vm._v("Proceder a pagar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }